<div class="bell-notification-wrapper">
  <button
    type="button"
    class="bell-button"
    (click)="togglePanel($event)"
    [pTooltip]="'app.bellNotification.tooltip' | translate"
    tooltipPosition="bottom"
    [attr.aria-label]="'app.bellNotification.tooltip' | translate"
  >
    @if (hasUnread()) {
      <em
        class="pi pi-bell"
        pBadge
        severity="danger"
        [value]="unreadCount().toString()"
        [badgeSize]="'small'"
      ></em>
    } @else {
      <em class="pi pi-bell"></em>
    }
  </button>

  <p-popover #notificationPanel [dismissable]="true">
    <div class="notification-panel">
      <div class="notification-header">
        <span class="notification-title">{{ 'app.bellNotification.title' | translate }}</span>
        @if (hasUnread()) {
          <button
            type="button"
            class="mark-all-btn"
            (click)="onMarkAllAsRead()"
          >
            {{ 'app.bellNotification.markAllAsRead' | translate }}
          </button>
        }
      </div>

      <div class="notification-list">
        @for (notification of notifications(); track notification.id) {
          <div
            class="notification-item"
            [class.unread]="!notification.read"
          >
            <div class="notification-icon" (click)="onNotificationClick(notification)">
              <em class="pi" [ngClass]="getTypeIcon(notification.type)"></em>
            </div>
            <div class="notification-content" (click)="onNotificationClick(notification)">
              <span class="notification-message">{{ notification.message }}</span>
              <span class="notification-date">{{
                notification.createdAt | date: 'dd/MM/yyyy HH:mm'
              }}</span>
            </div>
            @if (!notification.read) {
              <button
                type="button"
                class="mark-read-btn"
                (click)="onMarkOneAsRead(notification.id, $event)"
                [pTooltip]="'app.bellNotification.markAsRead' | translate"
                tooltipPosition="left"
                [attr.aria-label]="'app.bellNotification.markAsRead' | translate"
              >
                <em class="pi pi-check"></em>
              </button>
            }
          </div>
        } @empty {
          <div class="notification-empty">
            <em class="pi pi-inbox"></em>
            <span>{{ 'app.bellNotification.empty' | translate }}</span>
          </div>
        }
      </div>
    </div>
  </p-popover>
</div>
